export default __webpack_public_path__ + "da52dbfecc5056e9560e5800d906149c.svg";